<template>
  <div class="PersonelIoInfoInDateListWeb">
    <v-data-table
      dense
      :disable-sort="true"
      :headers="headers"
      :items="list"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      @click:row="handleClick"
    >
      
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    list() {
      this.selectedList = [];
    },
  },
  data() {
    return {
      selectedList: [],
      headers: [
        {
          text: this.$t("card-no"),
          value: "PERNO",
        },
        {
          text: this.$t("person-name"),
          value: "personName",
        },
        {
          text: this.$t("RozHozoor"),
          value: "days",
        },
        {
          text: this.$t("EzafekariMojaz"),
          value: "extraWorkMojaz",
        },
        {
          text: this.$t("MISSION"),
          value: "missionKol",
        },
        {
          text: this.$t("MorakhasiEstehghaghi"),
          value: "vacationEstehghaghi",
        },
        {
          text: this.$t("MorakhasiBedoneHoghogh"),
          value: "vacationBihoghogh",
        },
        {
          text: this.$t("koleKarkard"),
          value: "koleKarkard",
        },
        {
          text: this.$t("KasreKar"),
          value: "nonWork",
        },
        
      ],
    };
  },
  methods: {
    handleClick(value) {
      this.$emit("onClick", value);
    },
  },
};
</script>

<style>
</style>